import React from 'react';
import { isEmpty } from 'ramda';
import GameCardsGridVirtualized from '../../components/GameCardsGrid/GameCardsGridVirtualized';
import ReviewTwoColumnLayout from '../../layouts/TwoColumnLayout/TwoColumnLayout';
import NoContentPlaceholder from '../../../components/NoContentPlaceholder/NoContentPlaceholder';
import ScrollRestoration from '../../../components/ScrollRestoration/ScrollRestoration';
import AppReviewHeader from '../../components/AppReviewHeader/AppReviewHeader';
import { useQueryFavouriteGames } from '../../../hooks/API/useQueryFavouriteGames';
import { DEFAULT_QUERY_LIMIT } from '../../../hooks/API/constants';

export const Favorites = () => {
  const { isLoading, isSuccess, data } = useQueryFavouriteGames();

  return (
    <ScrollRestoration>
      <ReviewTwoColumnLayout>
        <AppReviewHeader />
        {isSuccess && isEmpty(data) ? (
          <NoContentPlaceholder
            image="star"
            title="Your favorite games will be here"
          />
        ) : (
          <GameCardsGridVirtualized
            items={data}
            isLoading={isLoading}
            limit={DEFAULT_QUERY_LIMIT}
          />
        )}
      </ReviewTwoColumnLayout>
    </ScrollRestoration>
  );
};

export default Favorites;
